import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://backend.tenderwise.xyz/api/v1',
  // baseURL: 'http://192.168.0.229:9009/api/v1',
});

// Request interceptor to add token to all requests
apiClient.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token');
    const bearer = localStorage.getItem('bearer');

    if (!token && bearer) {
      localStorage.setItem('token', bearer);
      token = bearer; // Auto-set token if bearer exists but token is missing
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

// Response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  response => response,
  async error => {
    if (error.response?.status === 401) {
      console.warn(
        'Unauthorized request detected. Clearing session and redirecting...'
      );

      // Clear session storage
      localStorage.clear();

      // Redirect to login (optional)
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default apiClient;


// old 3/06/25
// import axios from 'axios';
// const apiClient = axios.create({
//   // baseURL: 'http://192.168.0.228:9009/api/v1',
//   baseURL: 'https://backend.tenderwise.xyz/api/v1',
// });

// // Request interceptor to add token to all requests
// apiClient.interceptors.request.use(
//   config => {
//     let token = localStorage.getItem('token');
//     const bearer = localStorage.getItem('bearer');

//     // console.log("token:",token);
//     // console.log('bearer:', bearer);

//     if (!token && bearer) {
//       localStorage.setItem('token', bearer);
//       token = bearer; // Auto-set token if bearer exists but token is missing
//     }

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
//   },
//   error => Promise.reject(error)
// );

// // Response interceptor to handle responses
// apiClient.interceptors.response.use(
//   response => response, // Success response
//   error => {
//     if (error.response && error.response.status === 401) {
//       console.warn('Unauthorized request, but tokens are not removed.');
//       // You can handle unauthorized cases here without clearing tokens
//             localStorage.removeItem('bearer');
//             localStorage.removeItem('token');
//             localStorage.removeItem('premium_user');
//       localStorage.removeItem('user_type');
//           localStorage.removeItem('premium_user_i');
//           localStorage.removeItem('user_type_i');
//     }
//     return Promise.reject(error);
//   }
// );

// export default apiClient;

// old 2/26/25
// import axios from 'axios';
// const apiClient = axios.create({
//   // baseURL: 'http://46.250.230.174:9009/api/v1',
//   baseURL: 'http://192.168.0.228:9009/api/v1',
//   // baseURL: 'https://backend.tenderwise.xyz/api/v1',
// });

// // Request interceptor to add token to all requests
// apiClient.interceptors.request.use(
//   config => {
//     const bearer = localStorage.getItem('bearer');
//     const token = localStorage.getItem('token');

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     } else if (bearer) {
//       config.headers.Authorization = `Bearer ${bearer}`;
//     }

//     // if (bearer) {
//     //   config.headers.Authorization = `Bearer ${bearer}`;
//     // } else if (token) {
//     //   config.headers.Authorization = `Bearer ${token}`;
//     // }
//     return config;
//   },
//   error => Promise.reject(error)
// );

// // Response interceptor to handle responses
// apiClient.interceptors.response.use(
//   response => response, // Success response
//   error => {
//     if (error.response && error.response.status === 401) {
//       // Clear token and user data from localStorage
// localStorage.removeItem('bearer');
// localStorage.removeItem('token');
// localStorage.removeItem('premium_user');
// localStorage.removeItem('user_type');
//     }
//     return Promise.reject(error);
//   }
// );

// export default apiClient;

// old
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// // Create an instance of axios
// const apiClient = axios.create({
//   // baseURL: 'http://192.168.0.230:9009/api/v1',
//   baseURL: 'http://192.168.0.230:9009/api/v1',
// });

// // Request interceptor to add token to all requests
// apiClient.interceptors.request.use(
//   config => {
//     const bearer = localStorage.getItem('bearer');
//     const token = localStorage.getItem('token');
//     const premium_user = localStorage.getItem('premium_user');
//     const user_type = localStorage.getItem('user_type');

//     if (bearer) {
//       config.headers.Authorization = `Bearer ${bearer}`;
//       console.log('Authorization header set:', config.headers.Authorization);
//     } else if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//       console.log(
//         'Authorization header from Invoice set:',
//         config.headers.Authorization
//       );
//     } else {
//       console.warn('No token found, request may be unauthorized.');
//     }
//     return config;
//   },
//   error => Promise.reject(error)
// );

// // Response interceptor to handle responses
// apiClient.interceptors.response.use(
//   response => {
//     return response; // Success response
//   },
//   error => {
//     if (error.response && error.response.status === 401) {
//       // Handle unauthorized requests (e.g., redirect to login)
//       console.log('Unauthorized, redirecting to login...');
//       localStorage.removeItem('bearer'); // Clear the token
//       // onLogout();
//       // navigate('/login')
//       // window.location.href = '/login';
//       // Instead of using window.location.href, consider using a custom navigation function
//       // Return a rejected promise to handle it in the component
//       return Promise.reject(error);
//     }
//     return Promise.reject(error);
//   }
// );

// export default apiClient;
